import { v4 as uuidv4 } from "uuid";
import { CartItemType } from "../../services/redux/types/CartLoyaltyV2Types";
import {
  OrderCartV2LineAppliedOffer,
  OrderCartV2ResponseLine,
} from "../../services/redux/types/OrderCartV2Types";
import { ItemDetailsType, SubItemType } from "../types";

type LoyaltyLineType = {
  lineId: string;
  subItemDetails: SubItemType;
  itemDetails: ItemDetailsType;
  note: string;
  count: number;
  totalPrice: number;
  version: number;
  isFreeItem?: boolean;
  priceWithoutOffer?: number;
  isDiscountedItem?: boolean;
  customDeliveryTime?: number;
  excludeFromOffers?: boolean;
  excludeFromPointsPayment?: boolean;
  discountedItemPercentage?: number;
  appliedOffer?: OrderCartV2LineAppliedOffer;
  excludedFromTotals?: boolean;
};

type LoyaltyLineInput = {
  note: string;
  count: number;
  totalPrice: number;
  subItemDetails: SubItemType;
  itemDetails: ItemDetailsType;
  version: number;
  isFreeItem?: boolean;
  discountedItemPercentage?: number;
  customDeliveryTime?: number;
  excludeFromOffers?: boolean;
  excludeFromPointsPayment?: boolean;
  priceWithoutOffer?: number;
  isDiscountedItem?: boolean;
  appliedOffer?: OrderCartV2LineAppliedOffer;
  lineId?: string;
};

export class LoyaltyLine implements LoyaltyLineType {
  lineId: string;
  subItemDetails: SubItemType;
  itemDetails: ItemDetailsType;
  note: string;
  count: number;
  totalPrice: number;
  version: number;
  isFreeItem?: boolean;
  priceWithoutOffer?: number;
  isDiscountedItem?: boolean;
  customDeliveryTime?: number;
  excludeFromOffers?: boolean;
  excludeFromPointsPayment?: boolean;
  discountedItemPercentage?: number;
  appliedOffer?: OrderCartV2LineAppliedOffer;
  excludedFromTotals?: boolean;

  private constructor(fields: LoyaltyLineType) {
    this.lineId = fields.lineId;
    this.subItemDetails = fields.subItemDetails;
    this.itemDetails = fields.itemDetails;
    this.note = fields.note;
    this.count = fields.count;
    this.totalPrice = fields.totalPrice;
    this.version = fields.version;
    this.isFreeItem = fields.isFreeItem;
    this.priceWithoutOffer = fields.priceWithoutOffer;
    this.isDiscountedItem = fields.isDiscountedItem;
    this.customDeliveryTime = fields.customDeliveryTime;
    this.excludeFromOffers = fields.excludeFromOffers;
    this.excludeFromPointsPayment = fields.excludeFromPointsPayment;
    this.discountedItemPercentage = fields.discountedItemPercentage;
    this.appliedOffer = fields.appliedOffer;
    this.excludedFromTotals = fields.excludedFromTotals;
  }

  static create(input: LoyaltyLineInput, lineId?: string): LoyaltyLine {
    return new LoyaltyLine({
      lineId: lineId ?? input.lineId ?? uuidv4(),
      subItemDetails: input.subItemDetails,
      itemDetails: input.itemDetails,
      note: input.note,
      count: input.count,
      totalPrice: input.totalPrice,
      version: input.version,
      isFreeItem: input.isFreeItem,
      priceWithoutOffer: input.priceWithoutOffer,
      isDiscountedItem: input.isDiscountedItem,
      customDeliveryTime: input.customDeliveryTime,
      excludeFromOffers: input.excludeFromOffers,
      excludeFromPointsPayment: input.excludeFromPointsPayment,
      discountedItemPercentage: input.discountedItemPercentage,
      appliedOffer: input.appliedOffer,
    });
  }

  static createFromOfferItem(
    input: LoyaltyLineInput,
    lineId?: string
  ): LoyaltyLine {
    return LoyaltyLine.create(
      {
        ...input,
        isFreeItem: input.isFreeItem ?? true,
      },
      lineId
    );
  }

  static fromResponseLine(
    line: OrderCartV2ResponseLine,
    subItemDetails: SubItemType,
    itemDetails: ItemDetailsType,
    version = 1
  ): LoyaltyLine {
    const { subtotal, discount = 0, total } = line.pricing;

    return new LoyaltyLine({
      lineId: line.lineId,
      subItemDetails,
      itemDetails,
      note: line.note ?? "",
      count: line.quantity,
      totalPrice: total,
      version,
      priceWithoutOffer: discount > 0 ? subtotal : undefined,
      isFreeItem: total === 0,
      isDiscountedItem: discount > 0,
      appliedOffer: line.appliedOffer,
      excludedFromTotals: line.excludedFromTotals,
      excludeFromOffers: line.isExcludedFromOffers,
      excludeFromPointsPayment: line.isExcludedFromPointsPayment,
    });
  }

  toDisplayItem(): CartItemType {
    return {
      lineId: this.lineId,
      subItemDetails: this.subItemDetails,
      itemDetails: this.itemDetails,
      note: this.note,
      count: this.count,
      totalPrice: this.totalPrice,
      version: this.version,
      isFreeItem: this.isFreeItem,
      priceWithoutOffer: this.priceWithoutOffer,
      isDiscountedItem: this.isDiscountedItem,
      customDeliveryTime: this.customDeliveryTime,
      excludeFromOffers: this.excludeFromOffers,
      excludeFromPointsPayment: this.excludeFromPointsPayment,
      discountedItemPercentage: this.discountedItemPercentage,
      appliedOffer: this.appliedOffer,
      excludedFromTotals: this.excludedFromTotals,
    };
  }
}
